//develop
// const API = 'http://testcustomer.reflower.com.cn';
// const USER= 'https://i.ce.reflower.com.cn/api/user/getUserInfo';
// const UPLOAD = 'https://i.ce.reflower.com.cn/order/file/image/upload'
// const servicePage = 'https://i.ce.reflower.com.cn/api/user/community/getpage'
// const loginurl = 'https://my.ce.reflower.com.cn/login/tologin?redirecturi='
// const getdetail = 'https://i.ce.reflower.com.cn/api/user/community/getdetail'
//product
//const API = 'https://g.reflower.com.cn/customer';
//const USER= 'https://i.reflower.com.cn/api/user/getUserInfo';
//const UPLOAD = 'https://i.reflower.com.cn/order/file/image/upload'
//const servicePage = 'https://i.reflower.com.cn/api/user/community/getpage'
//const loginurl = 'https://my.reflower.com.cn/login/tologin?redirecturi='
//const getdetail = 'https://i.reflower.com.cn/api/user/community/getdetail'

//process.env 环境变量
const API         = process.env.API;
const USER        = process.env.USER;
const UPLOAD      = process.env.UPLOAD;
const servicePage = process.env.SERVICEPAGE;
const loginurl    = process.env.LOGINURL;
const getdetail   = process.env.GETDETAIL;
const eccpUrl     = process.env.ECCPURL;

export default{
	//ordersUrl : API + '/order/list',                //订单列表
	ordersUrl : API + '/order/listNew',             //新订单列表 2019-10-17
	createForm: API + '/afterServiceForm',          //创建申请单
	applyList : API + '/afterServiceForm/list',     //售后申请单
	details   : API + '/afterServiceForm/details/', //申请单详情
	replyList : API + '/afterServiceReply/list',    //申请单回复列表
	userSave  : API + '/afterServiceReply/save',    //创建回复
	appraise  : API + '/afterServiceForm/appraise', //评价申请单

	//2022-01-26 退货单
	refundDetail: API + '/afterServiceDetail/details/', //退货单详情
	addExpress:   API + '/afterServiceForm/addLogistics', //填写快递单号
	cancelApply:  API + '/afterServiceForm/cancelAfter/', //取消售后申请单

  eccpUrl: eccpUrl + '/account/QRCodeVerify', //二维码过期校验
  signSubmitUrl: eccpUrl + '/account/signSubmit', //签字提交
  eccpUploadUrl: eccpUrl + '/file/uploadFile', //eccp 图片上传


	loginurl : loginurl,
	wechaturl: 'https://w.reflower.com.cn?redirecturi=',
	alipayurl: 'https://my.reflower.com.cn/login/aliauth?redirecturi=',
  // wechaturl: 'https://w-ce.reflower.com.cn?redirecturi=',
  // alipayurl: 'https://my-ce.reflower.com.cn/login/aliauth?redirecturi=',
	userInfo :  USER,
	upload   : UPLOAD,
	servicePage : servicePage,
	getdetail : getdetail

}



// WEBPACK FOOTER //
// ./src/api.js